import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.highlightActiveLink();
    document.addEventListener("turbo:morph", this.highlightActiveLink);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.highlightActiveLink);
  }

  highlightActiveLink = () => {
    const currentPath = window.location.pathname;
    let activeLink = this.findBestMatch(currentPath);

    if (activeLink) {
      this.setActive(activeLink.closest(".nav-item"));
    }
  };

  highlight(event) {
    const navItem = event.target.closest(".nav-item");
    if (navItem) {
      this.setActive(navItem);
    }
  }

  setActive(navItem) {
    this.element
      .querySelectorAll(".nav-item.active")
      .forEach((item) => {
        item.classList.remove("active");
        const link = item.querySelector(".nav-link");
        if (link) link.removeAttribute("aria-current");
      });

    if (navItem) {
      navItem.classList.add("active");
      const link = navItem.querySelector(".nav-link");
      if (link) link.setAttribute("aria-current", "page");
    }
  }

  findBestMatch(currentPath) {
    const allLinks = this.element.querySelectorAll(".nav-link[href]");
    let bestMatch = null;
    let longestMatch = 0;

    allLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;

      const linkPath = new URL(href, window.location.origin).pathname;

      if (linkPath === "/") {
        if (currentPath === "/") bestMatch = link;
        return;
      }

      if (currentPath.startsWith(linkPath)) {
        const nextChar = currentPath.charAt(linkPath.length);
        if (nextChar === "" || nextChar === "/") {
          if (linkPath.length > longestMatch) {
            longestMatch = linkPath.length;
            bestMatch = link;
          }
        }
      }
    });

    return bestMatch;
  }
}
